import type { HelpFile } from '../../types/help'
import { JobExecutionsTestIds } from '../../../testids/JobExecutionsTestIds'

export const jobExecutionsHelp: HelpFile = {
  docPage: '/docs/jobs/job-scheduler',
  texts: {
    [JobExecutionsTestIds.jobExecutionsPage]:
      'Alle jüngsten Ausführungen geplanter oder manuell ausgelöster Jobs — zum Bestätigen, ob ein Job gelaufen ist, und zur Fehleranalyse.',
    [JobExecutionsTestIds.btnClearJobFilter]: null,
    [JobExecutionsTestIds.colJobName]:
      'Welcher Job gelaufen ist — Klick öffnet die Detailseite mit Definition und vollständiger Historie.',
    [JobExecutionsTestIds.colNode]:
      'Cluster-Knoten, der diese Ausführung übernommen hat — hilfreich bei der Diagnose knotenspezifischer Probleme.',
    [JobExecutionsTestIds.colStarted]:
      'Startzeitpunkt — in Kombination mit der Dauer fallen Abweichungen vom geplanten Startzeitpunkt auf.',
    [JobExecutionsTestIds.colTasks]:
      'Anzahl verarbeiteter Aufgaben dieser Ausführung — bei Fan-out-Jobs die Arbeitsmenge pro Lauf.',
  },
}
